// Why does this exists?
// Figma can't parse the JS bundle if we import zod.  Wtf is figma doing really.
// Until we fix that issue, we can't import model.ts values (types are ok) from
// the figma plugin.

export const DEFAULT_HOME_SPACE_NAME = 'Sitemap';
